







import { computed, defineComponent } from '@nuxtjs/composition-api';
import type { ComputedRef } from '@nuxtjs/composition-api';
import Breadcrumbs from '~/components/atoms/Breadcrumbs.vue';
import { Breadcrumb } from '~/types/components/Breadcrumbs/Breadcrumb';
import { useCategories, useCategoryTree } from '~/composables';
import { prepareBreadcrumb } from '~/helpers/prepareBreadcrumb/prepareBreadcrumb';
import { getCategoryPath } from '~/helpers/category/getCategoryPath';

export default defineComponent({
  name: 'CategoryBreadcrumbs',
  components: {
    Breadcrumbs,
  },
  setup() {
    const { activeCategories } = useCategories();
    const { categoryTree } = useCategoryTree();

    const breadcrumbList: ComputedRef<Breadcrumb[]> = computed(() =>
      activeCategories.value?.slice()
        .map(
          (category, index) => (prepareBreadcrumb(
            category?.name || '',
            getCategoryPath(category?.slug, categoryTree.value) || '',
            index,
          ))),
    );

    return {
      breadcrumbList,
    };
  },
});

